import { ref } from 'vue'

// Module-level state so every caller (pages and NotificationManager) shares one
// list. Created inside the function, each call got its own list and no toast
// was ever displayed.
const notifications = ref([])
let nextId = 1

export const useNotificationStore = () => {

    const addNotification = (notification) => {
        const id = nextId++
        const newNotification = {
            id,
            type: notification.type || 'info',
            title: notification.title,
            message: notification.message,
            duration: notification.duration || 5000,
            show: true
        }

        notifications.value.push(newNotification)

        // Auto-remove after duration
        if (newNotification.duration > 0) {
            setTimeout(() => {
                removeNotification(id)
            }, newNotification.duration)
        }

        return id
    }

    const removeNotification = (id) => {
        const index = notifications.value.findIndex(n => n.id === id)
        if (index > -1) {
            notifications.value.splice(index, 1)
        }
    }

    const showSuccess = (title, message = '', duration = 5000) => {
        return addNotification({ type: 'success', title, message, duration })
    }

    const showError = (title, message = '', duration = 7000) => {
        return addNotification({ type: 'error', title, message, duration })
    }

    const showWarning = (title, message = '', duration = 5000) => {
        return addNotification({ type: 'warning', title, message, duration })
    }

    const showInfo = (title, message = '', duration = 5000) => {
        return addNotification({ type: 'info', title, message, duration })
    }

    const clearAll = () => {
        notifications.value = []
    }

    return {
        notifications,
        addNotification,
        removeNotification,
        showSuccess,
        showError,
        showWarning,
        showInfo,
        clearAll
    }
} 